import { styled } from 'Theme'

export const StyledHideWhileLoading = styled.div`
  position: relative;
`

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  background: ${({ theme }): string => theme.colors.white};
  opacity: 0.9;

  display: flex;
  align-items: center;
  justify-content: center;
`
